/**
 * PazientiElenco.jsx — l'elenco dei pazienti dello stile dell'utenza
 * (interruttore dello stile, Alex 14/10/2026).
 *
 * Con lo stile di prima e' PazientiList, tale e quale a 638a8209 (piu' le
 * due correzioni funzionali dichiarate); con lo stile nuovo «Console» e'
 * PazientiListConsole, che ha in piu' il filtro «Da completare», la riga che
 * dice che un elenco non e' arrivato, e il numero del menu come collegamento.
 * Due componenti e non una condizione dentro uno solo: a interruttore spento
 * il disegno e' lo stesso di prima per costruzione, e quando il vecchio
 * stile si toglie si cancella un file e non si ripulisce un componente.
 * Lo stile lo decide il server e arriva con l'utente (navigazione/paginaIniziale).
 *
 * @varianti PazientiList.jsx PazientiListConsole.jsx
 */
import React from 'react';
import { useAuthStore } from '../../store/useStore';
import { stileNuovo } from '../../navigazione/paginaIniziale';
import PazientiList from './PazientiList';
import PazientiListConsole from './PazientiListConsole';

const PazientiElenco = () => {
    const utente = useAuthStore((st) => st.user);
    return stileNuovo(utente) ? <PazientiListConsole /> : <PazientiList />;
};

export default PazientiElenco;
